// src/App.js

import React from 'react'
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import PrivateRoute from './routes/PrivateRoute'
import './i18n'
import Navbar from './components/Navbar'

import Profile from './pages/Profile'
import Login from './pages/Login'
import ForgotPassword from './pages/ForgotPassword'
import DashboardPage from './pages/DashboardPage'
import AdminUsersPage from './pages/AdminUsersPage'
import EmergencyPage from './pages/EmergencyPage'
import EmergencyReportPage from './pages/EmergencyReportPage'
import SupportRequestsPage from './pages/SupportRequestsPage'
import PopuliPage from './pages/PopuliPage'
import PopuliReportPage from './pages/PopuliReportPage'
import PopuliUserPage from './pages/PopuliUserPage'
import PopuliBotDemoPage from './pages/PopuliBotDemoPage'

function AppContent() {
  const { currentUser } = useAuth()
  const userEmail = currentUser?.email || ''

  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />

        <Route path="/" element={<Navigate to="/ProjectsPage" replace />} />

        <Route
          path="/ProjectsPage"
          element={
            <PrivateRoute>
              <DashboardPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          }
        />

        <Route
          path="/emergency"
          element={<PrivateRoute emergencyOnly><EmergencyPage /></PrivateRoute>}
        />
        <Route
          path="/emergency/reports"
          element={<PrivateRoute emergencyOnly><EmergencyReportPage /></PrivateRoute>}
        />
        <Route
          path="/emergency/support-requests"
          element={<PrivateRoute emergencyOnly><SupportRequestsPage /></PrivateRoute>}
        />

        <Route
          path="/admin-users"
          element={
            <PrivateRoute adminOnly>
              <AdminUsersPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/populi/documents"
          element={
            <PrivateRoute>
              <PopuliPage userEmail={userEmail} />
            </PrivateRoute>
          }
        />

        <Route
          path="/populi/reports"
          element={
            <PrivateRoute>
              <PopuliReportPage userEmail={userEmail} />
            </PrivateRoute>
          }
        />

        <Route
          path="/populi/users"
          element={
            <PrivateRoute>
              <PopuliUserPage userEmail={userEmail} />
            </PrivateRoute>
          }
        />

        <Route
          path="/populi/demo"
          element={
            <PrivateRoute>
              <PopuliBotDemoPage userEmail={userEmail} />
            </PrivateRoute>
          }
        />

        <Route path="/PopuliPage" element={<Navigate to="/populi/documents" replace />} />
        <Route path="/PopuliReportPage" element={<Navigate to="/populi/reports" replace />} />
        <Route path="/PopuliUserPage" element={<Navigate to="/populi/users" replace />} />
        <Route path="/PopuliBotDemoPage" element={<Navigate to="/populi/demo" replace />} />

        <Route path="*" element={<Navigate to="/ProjectsPage" replace />} />
      </Routes>
    </>
  )
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  )
}

export default App
